(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalog-form-html"] && !Shopify.designMode) return;
  try {
    jQuery(document).ready(function ($) {
    $('form.catalog-form').on('submit', function (e2) {
      // alert('what!');
      e2.preventDefault();
      // var $recaptcha = $(this).find('.g-recaptcha');
      // if ($recaptcha.length && window.not_robot === false) {
      //   return false;
      // }
      var $form = $(this);
      var action = this.dataset.action;
      if (!action) return null;
      $.ajax({
        method: 'POST',
        url: action,
        data: $(this).serialize(),
      }).done(function (response) {
        if (response.status === 'success') {
          var msg = $('.form-row__newsletter_result').data('success');
          $('.form-row__newsletter_result').html(msg).show();
          $form.trigger('reset');
        } else {
          $('.form-row__newsletter_result').html(response.status).show();
        }
      });
      return false;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-float"] && !Shopify.designMode) return;
  try {
    jQuery(document).ready(function ($) {
    const $float = $('.pdp-buyflow__float');
    const $actions = $('.product__actions .action--atc button');

    function checkVisibility() {
      if ($actions.length === 0) return; // safety check

      const windowTop = $(window).scrollTop();
      const actionsBottom = $actions.offset().top + $actions.outerHeight();

      // show only when product__actions has scrolled up off the page
      if (actionsBottom < windowTop) {
        $float.addClass('is-active');
      } else {
        $float.removeClass('is-active');
      }
    }

    // run on scroll and resize
    $(window).on('scroll resize', checkVisibility);
    checkVisibility();

    $('.pdp-buyflow__float button').on('click', function (e) {
      e.preventDefault();
      $(this).find('.loader').css('opacity', 1);
      $('#product-form').trigger('submit');

      //$('#product-form .product__actions .action--atc button').click();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
